// Global JavaScript for Shopify theme
// This file is required by Shopify and should contain essential functionality

// Basic theme functionality
document.addEventListener('DOMContentLoaded', function() {
  // Initialize theme
  console.log('Premium Marketing Theme loaded');
  
  // Add any essential global functionality here
  // This file is loaded on every page
});


